import React from "react";
import { getSwells } from "../api/ndbcAPI";
const BuoySwells = () => {
  getSwells();
  return <div></div>;
};

export default BuoySwells;
